<template>
	<b-navbar-nav class="mx-1 d-md-down-none" v-b-tooltip.hover title="On-Call">
		<b-nav-form>
		    <b-overlay
				:show="$store.getters['loading/isLoading']('settings')"
				rounded="circle"
				opacity="0.6"
				spinner-small
				spinner-variant="primary"
				class="d-inline-block">
					<b-button :disabled="!settings" class="rounded-circle navbar-btn" :variant="form.on_call ? 'success' : 'outline-info'" @click="updateSettings"><i class="fa-light fa-hourglass-start"></i></b-button>
			</b-overlay>
		</b-nav-form>
	</b-navbar-nav>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex"

export default {
	name: 'on-call-navbar-button',
    data() {
        return {
            form: new Form({
            	on_call: false,
            	consistency_token: null
            }),
        }
    },
    computed: {
    	...mapGetters('planning', ['getSettings']),
    	settings() {
    		return this.getSettings()
    	}
    },
    watch: {
        settings: {
            immediate: true,
            handler(val) {
                this.form.withData(val)
            }
        }
    },
    methods: {
    	...mapActions('planning', ['updateCalendarSettings']),
        updateSettings() {
        	this.form.populate({on_call: !this.form.on_call})
            this.updateCalendarSettings(this.form.data())
            .catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                }
            })
        }
    }
}
</script>